module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/getButton.af44a2ab.svg";